// extracted by mini-css-extract-plugin
module.exports = {"root":"CasinoLayout_root__Vb0VK","withSidebar":"CasinoLayout_withSidebar__Zz1_6","layout":"CasinoLayout_layout__kaUct","content":"CasinoLayout_content__dDpE7"};